module.exports = __webpack_public_path__ + "static/analiz-simay-f13da53a08d018aa895a40a08b9b0136.jpg";